import { render } from "./LinkCard.vue?vue&type=template&id=d8be379e&scoped=true"
import script from "./LinkCard.vue?vue&type=script&lang=js"
export * from "./LinkCard.vue?vue&type=script&lang=js"

import "./LinkCard.vue?vue&type=style&index=0&id=d8be379e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8be379e"]])

export default __exports__